var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCaretRight = function SvgIconCaretRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#343330",
    d: "m16.424 12.424-7.5 7.5A1.127 1.127 0 1 1 7.33 18.33l6.704-6.702-6.702-6.704A1.127 1.127 0 1 1 8.926 3.33l7.5 7.5a1.125 1.125 0 0 1-.002 1.594"
  })));
};
export default SvgIconCaretRight;